import './tracer';
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Scrollbars } from "react-custom-scrollbars";
import { useMediaQuery } from 'react-responsive'
import { withRouter } from "react-router-dom";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";

import Header from "./components/header";
import Footer from "./components/footer";
import { toggleAtBottom, updateLoginCredentials, refreshToken, verifyToken } from "./store/actions";
import { MainRouter, SessionRouter } from "./Router";
import Loader from "./sharedComponents/preloader";

require("dotenv").config();

const App = ({
	preloader,
	atBottom,
	toggleAtBottom,
	updateLoginCredentials,
	refreshToken,
	history,
	location,
	verifyToken,
	userDetails
}) => {
	const LSVariable = "MEDIWEIGHTLOSS_USER_DATA";

	const [scrollbar, setScrollbar] = useState(null);

	const mobilePages = ['/mobile', '/reset-password-request']

	useEffect(() => {
		scrollbar && scrollbar.scrollToTop();
	}, [location, scrollbar]);

	const handleScrollFrame = (e) => {
		if (atBottom && e.top !== 1) {
			toggleAtBottom(false);
		}
		if (!atBottom && e.top === 1) {
			toggleAtBottom(true);
		}
	};

	const logout = () => {
		localStorage.removeItem(LSVariable);
		history.push("/");
	};

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 767px)' });
	const isPrint = useMediaQuery({ query: 'print' });

	const handle_mobile = () => {
		localStorage.removeItem(LSVariable);
		history.push("/mobile");
	}

	if(!isPrint) {
		if(isTabletOrMobile && !mobilePages.includes(location.pathname)) {
			handle_mobile();
		}

		if(!isTabletOrMobile && location.pathname === '/mobile') {
			history.push("/");
		}
	}

	const [tokenOk, setTokenOk] = useState(false);

	const desideRouter = () => {
		const getLSVariable = localStorage.getItem(LSVariable);
		if (getLSVariable) {
			const userData = JSON.parse(getLSVariable);

			if (userData && userData.token) {
				const verifyFail = () => {
					logout();
				};
				const verifySuccess = (event) => {
					if (event && event.status >= 200 && event.status < 300) {
						const refreshSuccess = (event) => {
							event.json().then((data) => {
								localStorage.setItem(LSVariable, JSON.stringify(data));
								updateLoginCredentials(data, () => setTokenOk(true));
							});
						};
						refreshToken(userData, refreshSuccess, verifyFail);
					} else {
						logout();
					}
				};
				!tokenOk && verifyToken(userData, verifySuccess, verifyFail);
			} else {
				logout();
			}

			return userDetails && userDetails.user && userDetails.user.user_type === userData.user.user_type && tokenOk ? (
				<React.Fragment>
					<div className="main-container">
						<Header />
						<div className="body-wrapper">
							<Scrollbars ref={(elem) => setScrollbar(elem)} autoHide className="wrapper-scrollbar" onScrollFrame={handleScrollFrame}>
								<div className="body-container">
									<MainRouter />
									<Footer />
								</div>
							</Scrollbars>
						</div>
					</div>
					<NotificationContainer />
				</React.Fragment>
			) : (
					<Loader />
				);
		}
		return (
			<div className="main-container">
				<SessionRouter />
				<NotificationContainer />
			</div>
		);
	};

	return (
		<div className="main-wrap">
			<div className={`preloader-wrap ${preloader ? "shown" : "hidden"}`}>
				<div className="preloader" />
			</div>
			{desideRouter()}
		</div>
	);
};

const mapStateToProps = (state) => ({
	preloader: state.UI.preloader,
	atBottom: state.UI.atBottom,
	userDetails: state.Auth.userDetails
});

const mapDispatchToProps = {
	toggleAtBottom,
	updateLoginCredentials,
	refreshToken,
	verifyToken
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(App)
);
